import React from 'react'
import { Paragraph, colors, BillboardText, useContainerWidth, H2 } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import whatWeDo from './images/what-we-do.jpg'

const row = css`
  display: flex;
  flex-direction: wrap;
  align-items: center;
`
const imgSizingSmall = css`
  display: block;
  width: 100%;
`
const imgSizingLarge = css`
  display: block;
  width: 100%;
  height: 432px;
  object-fit: cover;
`
const imageSizingColumn = css`
  display: block;
  height: 432px;
  width: 50%;
  object-fit: cover;
`
const textContainerSmall = css`
  padding: 48px 24px;
  max-width: 560px;
  margin: 0 auto;
`
const textContainerLarge = css`
  padding: 72px 24px;
  max-width: 560px;
  margin: 0 auto;
`
const textContainerColumn = css`
  text-align: end;
  width: 50%;
  padding: 0 80px;
`
const textWithColumn = css`
  display: inline-block;
  max-width: 560px;
`
const overlineSmall = css`
  display: inline-block;
  background-color: ${colors.green50};
  width: 60px;
  height: 4px;
  margin-bottom: 24px;
`
const overlineLarge = css`
  display: inline-block;
  background-color: ${colors.green50};
  width: 84px;
  height: 4px;
  margin-bottom: 36px;
`
const bodyTextSpacer = css`
  margin-top: 12px;
  margin-bottom: 24px;
`

function WhatWeDoText() {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <div css={atWidth({ default: textContainerSmall, xs: textContainerLarge, xxl: textContainerColumn })}>
      <div css={textWithColumn}>
        <div css={atWidth({ default: overlineSmall, xs: overlineLarge })} />
        <BillboardText primaryColor={colors.green50}>
          <H2 size={atWidth({ default: 'H5', xs: 'H4' })}>{t('about.what-we-do.heading', 'What We Do')}</H2>
        </BillboardText>
        <div css={bodyTextSpacer}>
          <Paragraph size="md">
            {t(
              'about.what-we-do.body',
              'We help people discover their family’s history through our website, mobile apps, and in-person help at over 5,000 local family history centers.'
            )}
          </Paragraph>
        </div>
        <Paragraph size="sm">
          <Link to="/centers/about" linkName="about:find-local-center" external>
            {t('about.find-a-local-center.link', 'Find a local center')}
          </Link>
        </Paragraph>
        <Paragraph size="sm">
          <Link to="/help" linkName="about:help" external>
            {t('about.get-help-online.link', 'Get help online')}
          </Link>
        </Paragraph>
      </div>
    </div>
  )
}

export default function AboutPageWhatWeDo() {
  const atWidth = useContainerWidth()

  return (
    <div css={atWidth({ xxl: row })}>
      {atWidth({
        default: (
          <>
            <img css={atWidth({ default: imgSizingSmall, md: imgSizingLarge })} src={whatWeDo} alt="" />
            <WhatWeDoText />
          </>
        ),
        xxl: (
          <>
            <WhatWeDoText />
            <img css={imageSizingColumn} src={whatWeDo} alt="" />
          </>
        ),
      })}
    </div>
  )
}
